"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxCarousel = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _productBox = require("@ori/product-box");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _constants = require("../../constants");
var _utils = require("../../utils");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductBoxCarousel = ({
  analyticsPlacement,
  classNames,
  data,
  hideRating,
  hideSubscription,
  id,
  loading,
  mrpStatementEnabled,
  showSkeletonIfEmpty,
  slider,
  translations,
  withTranslationsProvider,
  mode = _productBox.ProductBoxMode.Concept,
  arrowsMode,
  title: titleProp,
  minWidth = 175,
  linkComponent
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const title = typeof titleProp === 'string' ? titleProp : titleProp?.text;
  const titleProps = typeof titleProp === 'string' ? undefined : titleProp;
  if (data.length < 1 && !loading && !showSkeletonIfEmpty) {
    return null;
  }
  const sortedData = (0, _utils.sortProductBoxesByAvailability)(data);
  const sliderOptions = (0, _utils.getSliderOptions)({
    slider,
    isMobile
  });
  const spacing = (0, _utils.getSpacingValue)(sliderOptions?.slides);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: classNames?.root,
    "data-testid": getTestId(_constants.PRODUCT_BOX_CAROUSEL),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
      hasFocusableSlides: true,
      className: classNames?.carousel,
      id: id,
      title: {
        text: title,
        component: 'h2',
        ...titleProps
      },
      slider: sliderOptions,
      loading: !!loading,
      pagination: {
        show: false
      },
      navigation: {
        position: 'outside',
        showArrows: !isMobile,
        arrowsMode,
        useBreakpointsPerView: true
      },
      children: !!loading || data.length < 1 && showSkeletonIfEmpty ? (0, _times.default)(_constants.DEFAULT_PRODUCT_BOX_SKELETON_COUNT).map(index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledCarouselSlide, {
        index: index,
        spacing: spacing,
        minWidth: minWidth,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_productBox.ProductBoxSkeleton, {
          animation: loading ? 'pulse' : false
        })
      }, index)) : sortedData.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledCarouselSlide, {
        index: index,
        spacing: spacing,
        minWidth: minWidth,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_productBox.ProductBox, {
          ...product,
          mode: mode,
          analyticsData: {
            placement: analyticsPlacement,
            position: index
          },
          hideRating: hideRating,
          hideSubscription: hideSubscription,
          mrpStatementEnabled: mrpStatementEnabled,
          translations: translations,
          withTranslationsProvider: withTranslationsProvider,
          linkComponent: linkComponent
        })
      }, product.code))
    })
  });
};
exports.ProductBoxCarousel = ProductBoxCarousel;
